import { createSlice } from '@reduxjs/toolkit';
import Strings from '@/constants/String';
import BaseApiState from '@/api/BaseApiState';
interface Location {
  coords: {
    latitude: number
    longitude: number
  }
  location: {
    city: string,
    state: string,
    pincode: string,
    locality: string,
    country: string
  }
}


let initialLocationDetails: Location = {
  coords: localStorage.getItem("coords") ? JSON.parse(localStorage.getItem("coords")) : null,
  location: localStorage.getItem("location") ? JSON.parse(localStorage.getItem("location")) : {
    city: null,
    state: null,
    pincode: null,
    locality: null,
    country: null
  },

}
const initialState = {
  themeMode: localStorage.getItem('theme') || 'light',
  isLoading: false,
  // location: localStorage.getItem("coords") ? JSON.parse(localStorage.getItem("coords")) : null,
  locationDetails: initialLocationDetails,
  // currentSelectedLocation: localStorage.getItem("currentSelectedLocation") ? localStorage.getItem("currentSelectedLocation") : Strings.popularCities.Hyderabad,
  // currentSelectedCity: localStorage.getItem("currentSelectedCity") ? localStorage.getItem("currentSelectedCity") : Strings.popularCities.Hyderabad,
 
  currentSelectedLocation: localStorage.getItem("currentSelectedLocation") ? localStorage.getItem("currentSelectedLocation") : null,
  currentSelectedCity: localStorage.getItem("currentSelectedCity") ? localStorage.getItem("currentSelectedCity") :null,
  isLocationSearchOpen: false,
  showBDLUserAccountPopUp:false,

  DBL_Details:null

}

const globalSlice = createSlice({
  name: 'globalState',
  initialState,
  reducers: {
    resetLocationCoords:(state)=>{
      state.locationDetails={
        coords: null,
        location: {
          city: null,
          state: null,
          pincode: null,
          locality: null,
          country: null
        },
      }
    },
    setDBL_Details:(state, action) => {
      state.DBL_Details = action.payload || null
    },
    setShowBDLUserAccountPopUp:(state, action) => {
      state.showBDLUserAccountPopUp = action.payload || false
    },
    setLocation: (state, action) => {
      state.locationDetails = action.payload as Location;
    },
    setisLoading: (state, action) => {
      state.isLoading = action.payload;
    },
    setCurrentSelectedLocation: (state, action) => {
      state.currentSelectedLocation = action.payload;
    },
    setCurrentSelectedCity: (state, action) => {
      state.currentSelectedCity = action.payload;
    },
    setIsLocationSearchOpen: (state, action) => {
      state.isLocationSearchOpen = action.payload as boolean;
    },
  },
});

export const {
  setLocation,
  setisLoading,
  setCurrentSelectedLocation,
  setCurrentSelectedCity,
  setIsLocationSearchOpen,
  setShowBDLUserAccountPopUp,
  setDBL_Details,
  resetLocationCoords,
} = globalSlice.actions;
export default globalSlice.reducer;

